import { WithNAFallback } from '@toggle/design-system';
import React from 'react';

import { formatNumberWithUnit } from '../../utils/utils';
import * as S from './PriceCell.styles';

interface NumberCellProps {
  value: number;
  useFallbackDash?: boolean;
  fallbackTooltip?: string;
}

export const PriceCell = ({
  value,
  useFallbackDash,
  fallbackTooltip,
}: NumberCellProps) => {
  const formattedValue = formatNumberWithUnit(value);

  return (
    <S.PriceTableValue>
      <WithNAFallback
        containerPadding="0 0 0 8px"
        check={formattedValue !== '-'}
        value={formattedValue}
        useFallbackDash={useFallbackDash}
        tooltip={fallbackTooltip}
      />
    </S.PriceTableValue>
  );
};
